import _defineProperty from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _slicedToArray from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
var _excluded = ["data"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { useMemo } from 'react';
import { createCoursesQuery, useCoursesQuery } from './coursesQuery';

var findNextLesson = function findNextLesson(_ref) {
  var course = _ref.course,
      nextCourse = _ref.nextCourse,
      lesson = _ref.lesson;

  if (lesson.isLastLessonInCourse && nextCourse) {
    return nextCourse.lessons[0];
  }

  if (lesson.isLastLessonInCourse) {
    return undefined;
  }

  var lessonIndex = lesson.lessonNumber - 1;
  var nextLessonIndex = lessonIndex + 1;
  return course.lessons[nextLessonIndex];
};

var getLesson = function getLesson(_ref2) {
  var courses = _ref2.courses,
      courseSlug = _ref2.courseSlug,
      lessonSlug = _ref2.lessonSlug;
  var courseIndex = courses.findIndex(function (course) {
    return course.slug === courseSlug;
  });

  if (courseIndex === -1) {
    throw new Error("Unable to find course with slug \"".concat(courseSlug, "\""));
  }

  var course = courses[courseIndex];
  var lesson = course.lessons.find(function (lesson) {
    return lesson.slug === lessonSlug;
  });

  if (!lesson) {
    throw new Error("Unable to find lesson with slug \"".concat(lessonSlug, "\""));
  }

  var nextCourse = courses.at(courseIndex + 1);
  lesson.nextLesson = findNextLesson({
    lesson: lesson,
    course: course,
    nextCourse: nextCourse
  });
  return lesson;
}; // Lesson query needs to fetch all courses data because we need to create
// a next lesson link and next lesson might be in the next course
// if we want to get the last lesson in the given course.


export var createLessonQuery = createCoursesQuery;
export var useLessonQuery = function useLessonQuery(_ref3) {
  var _ref3$args = _slicedToArray(_ref3.args, 1),
      _ref3$args$ = _ref3$args[0],
      courseSlug = _ref3$args$.courseSlug,
      lessonSlug = _ref3$args$.lessonSlug,
      options = _ref3.options;

  var _useCoursesQuery = useCoursesQuery({
    args: [],
    options: options
  }),
      courses = _useCoursesQuery.data,
      rest = _objectWithoutProperties(_useCoursesQuery, _excluded);

  var lesson = useMemo(function () {
    return getLesson({
      courses: courses !== null && courses !== void 0 ? courses : [],
      courseSlug: courseSlug,
      lessonSlug: lessonSlug
    });
  }, [courses, courseSlug, lessonSlug]);
  return _objectSpread({
    data: lesson
  }, rest);
};